"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNonStaticHolidays = exports.getEasterSunday = void 0;
const luxon_1 = require("luxon");
/**
 * Calculates easter day (sunday) by using Spencer Jones formula found here:
 * <a href="http://no.wikipedia.org/wiki/P%C3%A5skeformelen">Wikipedia -
 * Påskeformelen</a>
 */
const getEasterSunday = (inputYear) => {
    const a = inputYear % 19;
    const b = Math.floor(inputYear / 100);
    const c = inputYear % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const n = Math.floor((h + l - 7 * m + 114) / 31);
    const p = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(`${inputYear}-${n}-${p}`);
};
exports.getEasterSunday = getEasterSunday;
const subtractDays = (date, days) => {
    const copiedDateObj = new Date(date);
    copiedDateObj.setDate(copiedDateObj.getDate() - days);
    return copiedDateObj;
};
const addDays = (date, days) => {
    const copiedDateObj = new Date(date);
    copiedDateObj.setDate(copiedDateObj.getDate() + days);
    return copiedDateObj;
};
const getNonStaticHolidays = (currentYear) => {
    const easterDaySunday = (0, exports.getEasterSunday)(currentYear);
    return [
        { description: "Palmesøndag", date: subtractDays(easterDaySunday, 7) },
        { description: "Skjærtorsdag", date: subtractDays(easterDaySunday, 3) },
        { description: "Langfredag", date: subtractDays(easterDaySunday, 2) },
        { description: "1 påskedag", date: easterDaySunday },
        { description: "2 påskedag", date: addDays(easterDaySunday, 1) },
        { description: "Kristi Himmelfart", date: addDays(easterDaySunday, 39) },
        { description: "1 Pinsedag", date: addDays(easterDaySunday, 49) },
        { description: "2 Pinsedag", date: addDays(easterDaySunday, 50) },
    ];
};
exports.getNonStaticHolidays = getNonStaticHolidays;
const getAllHolidays = (currentYear) => {
    const allHolidays = [
        { description: "1 nyttårsdag", date: new Date(`${currentYear}-01-01`) },
        { description: "Arbeidernes Dag", date: new Date(`${currentYear}-05-01`) },
        { description: "Grunnlovsdagen 17 mai", date: new Date(`${currentYear}-05-17`) },
        { description: "1 juledag", date: new Date(`${currentYear}-12-25`) },
        { description: "2 juledag", date: new Date(`${currentYear}-12-26`) },
        ...(0, exports.getNonStaticHolidays)(currentYear),
    ];
    return allHolidays;
};
const isPublicHoliday = (date) => {
    const allHolidays = getAllHolidays(new Date(date).getFullYear());
    return allHolidays.some((item) => {
        const d1 = luxon_1.DateTime.fromJSDate(date);
        const d2 = luxon_1.DateTime.fromJSDate(item.date);
        return d1.hasSame(d2, "day");
    });
};
exports.default = isPublicHoliday;
